import * as actionTypes from '../actions/types';

const initialState = {
  trigger: {
    id: '',
    title: 'trigger',
    content: '',
    productIds: [],
    personaIds: [],
    connectorIds: [],
    personas: [],
    products: [],
    color: '#6488e3',
  },
  guide: {
    id: '',
    title: 'guide',
    content: '',
    productIds: [],
    personaIds: [],
    connectorIds: [],
    personas: [],
    products: [],
    color: '#1589ee',
  },
  key: {
    id: '',
    title: 'key',
    content: '',
    productIds: [],
    personaIds: [],
    connectorIds: [],
    personas: [],
    products: [],
    color: '#4bca81',
  },
  crisis: {
    id: '',
    title: 'crisis',
    content: '',
    productIds: [],
    personaIds: [],
    connectorIds: [],
    personas: [],
    products: [],
    color: '#fff03f',
  },
  triumph: {
    id: '',
    title: 'triumph',
    content: '',
    productIds: [],
    personaIds: [],
    connectorIds: [],
    personas: [],
    products: [],
    color: '#ff9e2c',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_MILESTONE:
      return {
        ...state,
        [action.stageName]: {
          ...state[action.stageName],
          id: action.id,
          content: action.content,
        },
      };
    case actionTypes.UPDATE_MILESTONE_CONNECTOR_ORDER:
      return {
        ...state,
        [action.stageName]: {
          ...state[action.stageName],
          connectorIds: action.connectorIds,
        },
      };
    case actionTypes.UPDATE_MILESTONE_PRODUCT:
      return {
        ...state,
        [action.stageName]: {
          ...state[action.stageName],
          productIds: [...action.products],
        },
      };
    case actionTypes.UPDATE_MILESTONE_PERSONA:
      return {
        ...state,
        [action.stageName]: {
          ...state[action.stageName],
          personaIds: [...action.personas],
        },
      };
    default:
      return state;
  }
};
